/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";
import UserShopSearch from "components/widgets/user/UserShopSearch";
import "components/elements/main/index.scss";
import { checkUserAllowed } from "helpers/utils.js";


const WholesaleUserShopsPageSearch = (props) => {

  const [state] = useState({
    layoutColumns: 3,
  });


    useEffect(() => {
    props.userMainResetSearchShops();
    document.getElementById("color").setAttribute("href", "#");
  }, []);

    return (
        <div>
            <UserShopSearch {...props} wholesale={true} colSize={state.layoutColumns} />
        </div>
    );

};

WholesaleUserShopsPageSearch.propTypes = {
    userMainResetSearchShops: PropTypes.func.isRequired,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const wholesaleUserShopsPageSearch = connect(
  ({ userMainShops, bootupInfo }) => ({
    bootupInfo,
      userDetails: bootupInfo.userDetails,
    reqStatus: userMainShops.reqStatus,
    isLoading: userMainShops.isLoading,
    serviceError: userMainShops.serviceError,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(WholesaleUserShopsPageSearch);

export { wholesaleUserShopsPageSearch as default };
